<div class="reports-page" [class.embedded-report-page]="embedded">
  <p-tabs class="reports-tabs" [(value)]="activeReportTab" (valueChange)="onReportTabChange($event)">
    @if (!embedded) {
      <p-tablist>
        @for (tab of reportTabs; track tab.value) {
          <p-tab [value]="tab.value">{{ tab.label }}</p-tab>
        }
      </p-tablist>
    }
    <p-tabpanels>
      <ng-template #dailyRepaymentsContent>
        <div class="report-panel" [class.has-contributing-detail]="selectedCell || selectedGroupedReportCell">
          <div class="report-toolbar">
            <div class="report-view-selector">
              <p-selectbutton [options]="dailyRepaymentViewOptions" [(ngModel)]="dailyRepaymentView" optionLabel="label" optionValue="value" [disabled]="loading" (onChange)="onDailyRepaymentViewChange()" />
            </div>
            <div class="metric-toggle" role="group" aria-label="Report metric">
              @if (dailyRepaymentView === 'this-month') {
                <div class="month-navigation" aria-label="Created month navigation">
                  <p-button icon="pi pi-chevron-left" severity="secondary" [outlined]="true" [disabled]="loading" ariaLabel="Previous month" (onClick)="showPreviousCreatedMonth()" />
                  <span>{{ selectedCreatedMonthLabel }}</span>
                  <p-button icon="pi pi-chevron-right" severity="secondary" [outlined]="true" [disabled]="loading || isCurrentCreatedMonth" ariaLabel="Next month" (onClick)="showNextCreatedMonth()" />
                </div>
              }
              @if (dailyRepaymentView === 'monthly') {
                <label class="monthly-all-sources-toggle">
                  <p-toggleswitch [(ngModel)]="monthlyAllSources" [disabled]="loading" (ngModelChange)="onMonthlyAllSourcesChange()" />
                  <span>All sources</span>
                </label>
              }
              @if (isWeeklyRepaymentView) {
                @for (option of metricOptions; track option.value) {
                  <p-button [label]="option.label" [severity]="metric === option.value ? 'primary' : 'secondary'" [outlined]="metric !== option.value" (onClick)="setMetric(option.value)" />
                }
                <p-button [label]="dateModeToggleLabel" icon="pi pi-calendar" [severity]="dateMode === 'created' ? 'primary' : 'secondary'" [outlined]="dateMode === 'repayment'" [disabled]="loading" (onClick)="toggleDateMode()" />
                <label class="days-control">
                  <span>Days back</span>
                  <input pInputText type="number" min="1" max="365" [ngModel]="daysBack" (change)="updateDaysBack($any($event.target).value)" aria-label="Days to include" />
                </label>
              }
            </div>
            <p class="description report-description">
              @if (isWeeklyRepaymentView) {
                Repayments by {{ dateFieldLabel.toLowerCase() }} from {{ daysBack }} days ago onwards. Adjustments are excluded.
              } @else if (dailyRepaymentView === 'this-month') {
                Repayments created in {{ selectedCreatedMonthLabel }}, grouped by repayment and created date. Adjustments are excluded.
              } @else if (isOperationsRecordView) {
                @if (dailyRepaymentView === 'gocardless') { All GoCardless repayments. }
                @else if (dailyRepaymentView === 'processor-fees') { Check processor fees of customers. }
                @else if (dailyRepaymentView === 'legal-fees-recovered') { Legal fees recovered. }
                @else { Write Off repayments since inception. }
                Scroll to load more records.
              } @else {
                Repayments grouped by repayment month. Adjustments are excluded.
              }
            </p>
          </div>

          @if (error) {
            <div class="error-banner">
              <span>{{ error }}</span>
              <p-button label="Retry" icon="pi pi-refresh" severity="danger" [outlined]="true" [disabled]="loading" (onClick)="retry()" />
            </div>
          }

          @if (isOperationsRecordView) {
            <app-operations-repayment-table
              [repayments]="operationsRepayments"
              [totalRecords]="operationsTotalRecords"
              [totalPaymentAmount]="operationsTotalPaymentAmount"
              [loading]="loading"
              [loadingMore]="operationsLoadingMore"
              [hasMore]="operationsHasMore"
              [layout]="operationsRecordLayout"
              (loadMore)="loadMoreOperationsRepayments()"
            />
          } @else if (isWeeklyRepaymentView) {
          <p-table
    [value]="tableRows"
    styleClass="reports-table"
    responsiveLayout="scroll"
    [scrollable]="true"
    stripedRows
    showGridlines
    [rowHover]="true"
  >
    <ng-template #colgroup>
      <colgroup>
        <col style="width: 10rem" />
        @for (source of dataSources; track source) {
          <col style="width: 9rem" />
        }
      </colgroup>
    </ng-template>
    <ng-template #header>
      <tr>
        <th>{{ dateFieldLabel }}</th>
        @for (source of dataSources; track source) {
          <th>{{ source }}</th>
        }
      </tr>
    </ng-template>
    <ng-template #body let-row>
      @if (loading) {
        <tr>
          <td><p-skeleton styleClass="w-full h-1rem" /></td>
          @for (source of dataSources; track source) {
            <td><p-skeleton styleClass="w-full h-1rem" /></td>
          }
        </tr>
      } @else {
        <tr>
          <td class="date-cell">{{ formatDate(row.repaymentDate) }}</td>
          @for (source of dataSources; track source) {
            <td class="value-cell" [class.selected-report-cell]="isSelectedCell(row, source)">
              <button
                type="button"
                class="report-value-button"
                [attr.aria-pressed]="isSelectedCell(row, source)"
                (click)="selectCell(row, source)"
              >
                {{ formatReportValue(row, source) }}
              </button>
            </td>
          }
        </tr>
      }
    </ng-template>
    <ng-template #footer>
      @if (!loading) {
        <tr>
          <td class="total-label">Total</td>
          @for (source of dataSources; track source) {
            <td class="value-cell total-value">{{ totalCountFor(source) === 0 ? '' : formatValue(totalFor(source)) }}</td>
          }
        </tr>
      }
    </ng-template>
    <ng-template #emptymessage>
      @if (!loading) {
        <tr>
          <td [attr.colspan]="dataSources.length + 1">No repayments were found for the selected date range.</td>
        </tr>
      }
    </ng-template>
          </p-table>

          } @else {
            <app-repayment-report-table
              [groups]="groupedReportRows"
              [dataSources]="dataSources"
              [showRepaymentDate]="dailyRepaymentView === 'this-month'"
              [dateColumnLabel]="dailyRepaymentView === 'monthly' ? 'Date' : 'Created date'"
              [loading]="loading"
              [emptyMessage]="dailyRepaymentView === 'this-month' ? 'No repayments were created in ' + selectedCreatedMonthLabel + '.' : 'No repayments were found.'"
              [selectedCell]="selectedGroupedReportCell"
              (cellSelected)="onGroupedReportCellSelected($event)"
            />
          }

          @if ((selectedCell || selectedGroupedReportCell) && !isOperationsRecordView) {
    <section class="repayment-detail" aria-live="polite">
      <div class="detail-header">
        <div>
          <h2>Contributing repayments</h2>
          <p>{{ selectedCell ? formatDate(selectedCell.date) + ' · ' + selectedCell.source : groupedReportCellLabel }}</p>
        </div>
        <div class="detail-actions">
          <p-button label="Export to CSV" icon="pi pi-download" severity="secondary" [outlined]="true" [disabled]="detailLoading || !detailRepayments.length" (onClick)="exportSelectedRepayments()" />
          <p-button label="Clear selection" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="clearSelection()" />
        </div>
      </div>

      @if (detailError) {
        <div class="error-banner"><span>{{ detailError }}</span></div>
      }

      <p-table
        [value]="detailTableRows"
        styleClass="reports-table repayment-detail-table"
        responsiveLayout="scroll"
        [scrollable]="true"
        scrollHeight="flex"
        stripedRows
        showGridlines
        [rowHover]="true"
        sortField="repayment_date"
        [sortOrder]="1"
      >
        <ng-template #header>
          <tr>
            <th pSortableColumn="repayment_date">Repayment date <p-sortIcon field="repayment_date" /></th>
            <th class="date-cell" pSortableColumn="created_date">Created date <p-sortIcon field="created_date" /></th>
            <th class="description-cell" pSortableColumn="description">Description <p-sortIcon field="description" /></th>
            <th pSortableColumn="payment_amount">Amount <p-sortIcon field="payment_amount" /></th>
            <th pSortableColumn="cash_advances.name">Customer number <p-sortIcon field="cash_advances.name" /></th>
          </tr>
        </ng-template>
        <ng-template #body let-repayment>
          @if (detailLoading) {
            <tr>
              @for (_ of [1, 2, 3, 4, 5]; track $index) {
                <td><p-skeleton styleClass="w-full h-1rem" /></td>
              }
            </tr>
          } @else {
            <tr>
              <td>{{ repayment.repayment_date ? formatDate(repayment.repayment_date) : '—' }}</td>
              <td>{{ repayment.created_date ? formatDate(repayment.created_date) : '—' }}</td>
              <td class="description-cell">{{ repayment.description || '—' }}</td>
              <td class="value-cell">{{ formatAmount(repayment.payment_amount) }}</td>
              <td class="value-cell">{{ cashAdvanceNumber(repayment) }}</td>
            </tr>
          }
        </ng-template>
        <ng-template #emptymessage>
          @if (!detailLoading) {
            <tr><td colspan="5">No repayments found for this report value.</td></tr>
          }
        </ng-template>
      </p-table>
    </section>
          }
        </div>
      </ng-template>
      <p-tabpanel value="legal">
        <section class="report-panel legal-report-panel" [class.has-contributing-detail]="legalView === 'internal-recoveries' && legalSelectedCell" aria-label="Legal report">
          <div class="report-toolbar">
            <div class="report-view-selector">
              <p-selectbutton [options]="legalViewOptions" [(ngModel)]="legalView" optionLabel="label" optionValue="value" [disabled]="legalLoading || loading" (onChange)="onLegalViewChange()" />
            </div>
            <p class="description report-description">
              @if (legalView === 'internal-recoveries') {
                Internal recoveries grouped by repayment month, from most recent to oldest. Select a payment value to view its contributing payments.
              } @else if (legalView === 'total-legal-repayments') {
                Monthly total payment amount for Legal repayments.
              } @else {
                Write Off repayments since inception.
              }
              Adjustments are excluded.
            </p>
          </div>
          @if (legalView === 'write-off-since-inception' ? error : legalError) {
            <div class="error-banner">
              <span>{{ legalView === 'write-off-since-inception' ? error : legalError }}</span>
              <p-button label="Retry" icon="pi pi-refresh" severity="danger" [outlined]="true" [disabled]="legalLoading || loading" (onClick)="retry()" />
            </div>
          }
          @if (legalView === 'internal-recoveries') {
            <app-legal-internal-recoveries-table
              [rows]="legalRows"
              [dataSources]="legalInternalRecoverySources"
              [loading]="legalLoading"
              [selectedCell]="legalSelectedCell"
              (cellSelected)="onLegalInternalRecoveryCellSelected($event)"
            />
          } @else if (legalView === 'total-legal-repayments') {
            <app-legal-repayments-chart [bars]="legalChartBars" [loading]="legalLoading" />
          } @else {
            <app-operations-repayment-table
              [repayments]="operationsRepayments"
              [totalRecords]="operationsTotalRecords"
              [totalPaymentAmount]="operationsTotalPaymentAmount"
              [loading]="loading"
              [loadingMore]="operationsLoadingMore"
              [hasMore]="operationsHasMore"
              [layout]="writeOffRecordLayout"
              (loadMore)="loadMoreOperationsRepayments()"
            />
          }
          @if (legalView === 'internal-recoveries' && legalSelectedCell) {
            <section class="repayment-detail" aria-live="polite">
              <div class="detail-header">
                <div>
                  <h2>Contributing payments</h2>
                  <p>{{ formatLegalRecoveryMonth(legalSelectedCell.month) }} · {{ legalSelectedCell.source ?? 'Total' }}</p>
                </div>
                <p-button label="Clear selection" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="clearLegalDetail()" />
              </div>
              @if (legalDetailError) { <div class="error-banner"><span>{{ legalDetailError }}</span></div> }
              <p-table [value]="legalDetailTableRows" styleClass="reports-table repayment-detail-table legal-contributing-table" responsiveLayout="scroll" [scrollable]="true" scrollHeight="flex" stripedRows showGridlines [rowHover]="true">
                <ng-template #header><tr><th>Merchant</th><th>Repayment Date</th><th>Created Date</th><th>Customer Number</th><th>Payment Amount</th></tr></ng-template>
                <ng-template #body let-row>
                  @if (legalDetailLoading) {
                    <tr>@for (_ of [1, 2, 3, 4, 5]; track $index) { <td><p-skeleton styleClass="w-full h-1rem" /></td> }</tr>
                  } @else {
                    <tr><td>{{ row.merchantName }}</td><td>{{ row.repaymentDate ? formatDate(row.repaymentDate) : '—' }}</td><td>{{ row.createdDate ? formatDate(row.createdDate) : '—' }}</td><td>{{ row.customerNumber }}</td><td class="value-cell">{{ formatAmount(row.paymentAmount) }}</td></tr>
                  }
                </ng-template>
                <ng-template #emptymessage>@if (!legalDetailLoading) { <tr><td colspan="5">No contributing payments were found.</td></tr> }</ng-template>
              </p-table>
            </section>
          }
        </section>
      </p-tabpanel>
      <p-tabpanel value="daily-repayments">
        <ng-container [ngTemplateOutlet]="dailyRepaymentsContent" />
      </p-tabpanel>
      <p-tabpanel value="all-sales">
        <section class="all-sales-panel" [class.has-contributing-detail]="selectedAllSalesCell" aria-label="Merchant report">
          <div class="all-sales-filters">
            @if (!isEmbeddedAllSales) {
              <label class="merchant-filter">
                <span>Merchant</span>
                <p-select
                  [options]="merchantOptions"
                  [(ngModel)]="selectedMerchantId"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Search merchants"
                  [filter]="true"
                  [showClear]="true"
                  [loading]="merchantOptionsLoading"
                  [disabled]="allSalesLoading"
                  (onFilter)="onMerchantFilter($event)"
                  (onChange)="onMerchantSelectionChange()"
                />
              </label>
            }
            <label class="terminal-only-filter">
              <p-toggleswitch [(ngModel)]="terminalOnly" [disabled]="allSalesLoading" (ngModelChange)="onTerminalOnlyChange()" />
              <span>Terminals only</span>
            </label>
          </div>

          @if (allSalesError) {
            <div class="error-banner">
              <span>{{ allSalesError }}</span>
              <p-button label="Retry" icon="pi pi-refresh" severity="danger" [outlined]="true" [disabled]="allSalesLoading" (onClick)="reloadAllSales()" />
            </div>
          }

          @if (!allSalesLoading && !allSalesError && !selectedMerchantId) {
            <div class="all-sales-empty-selection">Select a merchant to view their sales.</div>
          }

          @if (allSalesMerchantTables.length || allSalesLoading) {
            <app-all-sales-table [class.embed-adaptive-width]="isEmbeddedAllSales" [merchantTables]="allSalesMerchantTables" [loading]="allSalesLoading" [layout]="allSalesViewportLayout" [selectedCell]="selectedAllSalesCell" (cellSelected)="onAllSalesCellSelected($event)" />
          } @else {
            @if (selectedMerchantId) {
              <div class="all-sales-empty-selection">No repayments were found for the selected merchant.</div>
            }
          }

          @if (selectedAllSalesCell) {
            <section class="repayment-detail" aria-live="polite">
              <div class="detail-header">
                <div>
                  <h2>Contributing repayments</h2>
                  <p>{{ selectedAllSalesCell.month }} · {{ selectedAllSalesCell.terminalName }}</p>
                </div>
                <div class="detail-actions">
                  <p-button label="Export to CSV" icon="pi pi-download" severity="secondary" [outlined]="true" [disabled]="detailLoading || !detailRepayments.length" (onClick)="exportSelectedRepayments()" />
                  <p-button label="Clear selection" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="clearSelection()" />
                </div>
              </div>
              @if (detailError) { <div class="error-banner"><span>{{ detailError }}</span></div> }
              <p-table [value]="detailTableRows" styleClass="reports-table repayment-detail-table" responsiveLayout="scroll" [scrollable]="true" scrollHeight="500px" stripedRows showGridlines [rowHover]="true">
                <ng-template #header><tr><th>Repayment date</th><th class="description-cell">Description</th><th class="value-cell">Amount</th><th class="value-cell">Data source</th></tr></ng-template>
                <ng-template #body let-repayment>
                  @if (detailLoading) {
                    <tr>@for (_ of [1, 2, 3, 4]; track $index) { <td><p-skeleton styleClass="w-full h-1rem" /></td> }</tr>
                  } @else {
                    <tr><td>{{ repayment.repayment_date ? formatDate(repayment.repayment_date) : '—' }}</td><td class="description-cell">{{ repayment.description || '—' }}</td><td class="value-cell">{{ formatAmount(repayment.payment_amount) }}</td><td class="value-cell">{{ repayment.data_source || '—' }}</td></tr>
                  }
                </ng-template>
                <ng-template #emptymessage>@if (!detailLoading) { <tr><td colspan="4">No repayments found for this report value.</td></tr> }</ng-template>
              </p-table>
            </section>
          }
        </section>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
